<div class="flex justify-content-center align-items-center h-full"
     [ngStyle]="{ transform: 'rotate(' + rotation() + 'deg)' }">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.833984 6.66659H12.5007M12.5007 6.66659L6.66732 0.833252M12.5007 6.66659L6.66732 12.4999" [attr.stroke]="stroke()" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
